import { FONTS } from "../data/affirmations";

interface SplashScreenProps {
  onStart: () => void;
}

export function SplashScreen({ onStart }: SplashScreenProps) {
  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(160deg,#FFF0F3 0%,#FAF7F4 50%,#F0FFF4 100%)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px 24px", textAlign: "center", position: "relative", overflow: "hidden" }}>
      <style>{FONTS + `
        @keyframes float { 0%,100% { transform:translateY(0) } 50% { transform:translateY(-16px) } }
        @keyframes fadeUp { from { opacity:0;transform:translateY(20px) } to { opacity:1;transform:translateY(0) } }
      `}</style>

      {/* Background blobs */}
      <div style={{ position: "absolute", top: "-100px", right: "-100px", width: "400px", height: "400px", background: "radial-gradient(circle,#FADADD 0%,transparent 70%)", borderRadius: "50%", pointerEvents: "none" }} />
      <div style={{ position: "absolute", bottom: "-80px", left: "-80px", width: "320px", height: "320px", background: "radial-gradient(circle,#D4ECD4 0%,transparent 70%)", borderRadius: "50%", pointerEvents: "none" }} />

      {/* Floating emoji */}
      <div style={{ fontSize: "80px", animation: "float 3s ease infinite", marginBottom: "20px" }}>🚶‍♀️</div>

      {/* Label */}
      <div style={{ fontSize: "11px", letterSpacing: "6px", color: "#C9184A", textTransform: "uppercase", marginBottom: "6px", fontFamily: "'DM Sans',sans-serif", fontWeight: 700, animation: "fadeUp 0.5s ease" }}>
        london only
      </div>

      {/* Title */}
      <h1 style={{ fontFamily: "'Playfair Display',serif", fontStyle: "italic", fontWeight: 900, fontSize: "clamp(52px,14vw,80px)", color: "#1a1a1a", letterSpacing: "-3px", lineHeight: 0.9, marginBottom: "20px", animation: "fadeUp 0.5s 0.1s ease both" }}>
        Hot Girl<br />Walk
      </h1>

      {/* Subtitle */}
      <p style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "16px", color: "#888", maxWidth: "300px", lineHeight: 1.7, marginBottom: "20px", animation: "fadeUp 0.5s 0.2s ease both" }}>
        Real London routes. Iconic playlists. Weekly drops. Walk the streets your faves walked.
      </p>

      {/* Route tags */}
      <div style={{ display: "flex", gap: "8px", marginBottom: "48px", flexWrap: "wrap", justifyContent: "center", animation: "fadeUp 0.5s 0.3s ease both" }}>
        {["🖤 Amy · Camden", "🌸 Notting Hill", "👑 The Crown Walk", "☕ Fleabag Route"].map(t => (
          <span key={t} style={{ padding: "6px 14px", borderRadius: "50px", background: "#fff", border: "1px solid #EDE8E3", fontSize: "12px", fontFamily: "'DM Sans',sans-serif", color: "#666", fontWeight: 500 }}>
            {t}
          </span>
        ))}
      </div>

      {/* CTA button */}
      <button
        onClick={onStart}
        style={{ padding: "18px 52px", borderRadius: "50px", border: "none", cursor: "pointer", background: "#1a1a1a", color: "#fff", fontSize: "15px", fontWeight: 700, letterSpacing: "1.5px", textTransform: "uppercase", fontFamily: "'DM Sans',sans-serif", boxShadow: "0 12px 40px rgba(0,0,0,0.2)", animation: "fadeUp 0.5s 0.4s ease both" }}>
        Get Started ✨
      </button>

      <p style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: "#bbb", marginTop: "16px", animation: "fadeUp 0.5s 0.5s ease both" }}>
        Free · New London drops every week
      </p>
    </div>
  );
}
